module.exports = { "default": require("core-js/library/fn/reflect/apply"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/apply.js
// module id = Pqwt
// module chunks = 3